/* eslint-disable */
import React, { FC } from 'react';
import { ImageUpload } from 'components/molecules/image-upload';
import { RcFile } from 'antd/lib/upload';
import { Space, Typography } from 'antd';

const maxImageSize = 10; // in  Mb
const maxImageResolutions = { width: 150, height: 150 };

const { Text } = Typography;

const src =
  'https://s3.us-east-1.amazonaws.com/rocketlane-profile-pic-public/114/8ce747d6-1d3e-4f49-a973-d1c92a5609c8/57a76f05bd138de7db08688006bbe070--logo-sport-team-logo.jpg';

export const DemoImageUploadPage: FC = () => {
  const defaultBeforeUpload = (file: RcFile) => {
    const isValidSize = file.size / (1024 * 1024) < maxImageSize;
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      alert('invalid type');

      return false;
    }
    if (!isValidSize) {
      alert('bigger size');

      return false;
    }

    return new Promise<RcFile | void>((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.addEventListener('load', (event: any) => {
        const _loadedImageUrl = event.target.result as string;
        const image = document.createElement('img');

        image.src = _loadedImageUrl;
        image.addEventListener('load', () => {
          const { width, height } = image;

          if (
            width <= maxImageResolutions.width &&
            height <= maxImageResolutions.height
          ) {
            resolve(file);
          }
          alert('bigger dimensions');
          reject();
        });
      });
    });
  };
  return (
    <Space direction="vertical" size="large">
      <div>
        <h3> Available Props </h3>
        <Space direction="vertical">
          <Text code>src?: string - url for avatar</Text>
          <Text code>alt?: string - alt for avatar</Text>
          <Text code>icon?: ReactNode - Fallback icon for avatar</Text>
          <Text code>buttonText?: string - Upload button text</Text>
          <Text code>help?: string - Help text under upload button</Text>
          <Text code>
            maxSizeInMB?: number - Max size allowed for image upload
          </Text>
          <Text code> isDisabled?: boolean - Disable uploader</Text>
          <Text code>
            {' '}
            isLoading?: boolean - Loader on image and Upload, Uploader is
            disabled when this is true
          </Text>
          <Text code>
            {' '}
            showSizeRestriction?: boolean - (default - false) :Show/hide size
            restriction help text text - default text "Max 2MB ‧ Formats: png,
            jpeg, "
          </Text>
          <Text code>
            {' '}
            showFormatRestriction?: boolean - (default - false) :Show/hide
            format restriction help text text - default text "Formats: png,
            jpeg, "
          </Text>
          <Text code> onUpload: function - On upload function</Text>
          <Text code>beforeUpload: function - void - On upload function</Text>
        </Space>
      </div>
      <div>
        <h3> default uploader </h3>
        <ImageUpload
          isDisabled={false}
          isLoading={false}
          onUpload={() => {}}
          src={src}
        />
      </div>

      <div>
        <h3> Loading </h3>
        <ImageUpload isDisabled={false} isLoading={true} onUpload={() => {}} />
      </div>

      <div>
        <h3> Disabled </h3>
        <ImageUpload isDisabled={true} isLoading={false} onUpload={() => {}} />
      </div>

      <div>
        <h3> Customised content </h3>
        <h5> Custom conditions need custom `beforeUpload` function</h5>
        <ImageUpload
          isDisabled={false}
          isLoading={false}
          onUpload={() => {}}
          buttonText="Upload Avatar"
          help="Some help text"
          beforeUpload={defaultBeforeUpload}
        />
      </div>

      <Space direction="vertical">
        <h3> Restriction helper text </h3>
        <ImageUpload
          isDisabled={false}
          isLoading={false}
          onUpload={() => {}}
          src={src}
          showFormatRestriction={true}
        />

        <ImageUpload
          isDisabled={false}
          isLoading={false}
          onUpload={() => {}}
          src={src}
          showSizeRestriction={true}
        />

        <ImageUpload
          isDisabled={false}
          isLoading={false}
          onUpload={() => {}}
          src={src}
          showSizeRestriction={true}
          showFormatRestriction={true}
        />
      </Space>
    </Space>
  );
};
